import { HelpCircle } from "lucide-react";
import MotionSection from "../common/MotionSection";
import SectionHeading from "../common/SectionHeading";

function expandAnswer(answer, countryName) {
  const trimmed = (answer || "").trim();
  if (trimmed.length > 180) return trimmed;

  return `${trimmed} We also guide you with profile-based shortlisting, timeline planning, and visa documentation checkpoints so your ${countryName} journey stays practical and confidence-led from the first consultation.`;
}

function CountryFaqSection({ country }) {
  return (
    <MotionSection className="py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-6">
        <SectionHeading
          kicker="Quick Answers"
          title={`FAQs for ${country.name}`}
          description="Clear responses to common questions students and parents usually ask before planning the next step."
        />

        <div className="mt-10 space-y-4">
          {country.faq.map((item) => (
            <details
              key={item.q}
              className="group signature-card rounded-2xl p-5 open:border-royal-blue/35 open:bg-sky-glow/35"
            >
              <summary className="flex cursor-pointer list-none items-start justify-between gap-4 text-left">
                <span className="inline-flex items-start gap-2 text-base font-semibold text-midnight-navy md:text-lg">
                  <HelpCircle className="mt-0.5 h-4 w-4 text-royal-blue" aria-hidden="true" />
                  {item.q}
                </span>
                <span className="text-xs font-semibold uppercase tracking-[0.12em] text-royal-blue group-open:hidden">
                  Open
                </span>
                <span className="hidden text-xs font-semibold uppercase tracking-[0.12em] text-royal-blue group-open:block">
                  Close
                </span>
              </summary>
              <p className="mt-3 pl-6 text-sm leading-relaxed text-slate-text/82 md:text-[15px]">
                {expandAnswer(item.a, country.name)}
              </p>
            </details>
          ))}
        </div>
      </div>
    </MotionSection>
  );
}

export default CountryFaqSection;
